import { PURCHASE_ORDER_CREATE_PAGE } from "routes/route.constant";
import CreatePurchaseOrder from "./CreatePurchaseOrder";

const route = {
  path: PURCHASE_ORDER_CREATE_PAGE,
  element: CreatePurchaseOrder,
};

export default route;
